import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'credentials' })
export class CredentialsPipe implements PipeTransform {
  transform(value: string | null | undefined) {
    if (!value) {
      return;
    }

    return JSON.parse(atob(value.split('.')[1]))['client_id'] || '-';
  }
}
